import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAlpha = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.1 6C17 8.913 16.2 10.913 15.7 12M15.7 12C13.821 16.088 11.987 18 9.70002 18C7.30002 18 4.90002 15.6 4.90002 12C4.90002 8.4 7.30002 6 9.70002 6C11.967 6 13.835 7.986 15.7 12ZM15.7 12C16.212 13.102 17.012 15.102 18.1 18",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgAlpha;
